export default `float sdMenger(vec3 p, int iterations) {
    
    float d = sdBox(p, vec3(1.0));

    
    float s = 1.0;

    for(int i = 0; i < iterations; i++) {
        
        vec3 a = mod(p * s, 2.0) - 1.0;
        s *= 3.0;
        vec3 r = abs(1.0 - 3.0 * abs(a));

        
        float da = max(r.x, r.y);
        float db = max(r.y, r.z);
        float dc = max(r.z, r.x);
        float c = (min(da, min(db, dc)) - 1.0) / s;

        
        d = max(d, c);
    }

    return d;
}

float sdMengerUniform(vec3 p, int maxIterations) {
    return sdMenger(p, maxIterations);
}

float sdMengerAnimated(vec3 p, int iterations, float time) {
    
    p = rotateY(p, time * 0.2);
    p = rotateX(p, time * 0.15);

    return sdMenger(p, iterations);
}

float sdMengerScaled(vec3 p, int iterations, float scale) {
    
    p /= scale;

    
    return sdMenger(p, iterations) * scale;
}`